import React, { useState } from 'react';
import DataProviderListItem from './DataProviderListItem.view';
import DataProviderSearchListItem from './DataProviderSearchListItem.view';

import styles from './DataProviderSelector.module.scss';

export default function DataProviderSelector(props) {
  const {
    dataProviders,
    handleSelection,
  } = props;

  const [searchInput, setSearchInput] = useState('');

  return (
    <div className={styles.container}>
      <div className={styles.prompt}>Choose your bank:</div>
      <div>
        <input
          className={`${styles.search} form-control mx-auto`}
          type="search"
          placeholder="Search for more banks"
          aria-label="Search"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
        />
      </div>
      {
        searchInput ? (
          <div className="list-group border-bottom">
            {dataProviders
              .filter((p) => (
                p.name.toLowerCase().includes(searchInput.toLowerCase())
                || p.aliases?.some((a) => a.toLowerCase().includes(searchInput.toLowerCase()))
              ))
              .map((p) => (
                <DataProviderSearchListItem
                  key={p.selectedProvider.id}
                  id={p.selectedProvider.id}
                  displayName={p.name}
                  logo={p.selectedProvider.logo}
                  provider={p.selectedProvider}
                  handleSelection={handleSelection}
                />
              ))}
          </div>
        ) : (
          <ul className={styles.dataProviderList}>
            {dataProviders.filter((p) => !!p.displayOnLanding)
              .map((p) => (
                <DataProviderListItem
                  key={p.selectedProvider.id}
                  id={p.selectedProvider.id}
                  displayName={p.name}
                  logo={p.selectedProvider.logo}
                  provider={p.selectedProvider}
                  handleSelection={handleSelection}
                />
              ))}
          </ul>
        )
      }
    </div>
  );
}
